import { ServicePage } from "../components/ServicePage";
import { BEFORE_AFTER } from "../data/content";

const faq = [
    {
        q: "Ist Hochdruckreinigung schlecht für mein Pflaster?",
        a: "Nicht, wenn sie materialgerecht erfolgt. Ich passe Druck und Technik an die Oberfläche an: Betonpflaster verträgt deutlich mehr als empfindlicher Naturstein. Mit dem Flächenreiniger arbeite ich gleichmäßig und ohne die Fugen auszuspülen.",
    },
    {
        q: "Wie lange bleibt die Fläche sauber?",
        a: "Das hängt von Lage und Bewuchs der Umgebung ab. Sonnige, offene Flächen bleiben in der Regel mehrere Jahre gepflegt; schattige oder feuchte Bereiche bekommen schneller neuen Belag. Viele Kunden lassen stark beanspruchte Flächen im jährlichen oder zweijährlichen Rhythmus reinigen.",
    },
    {
        q: "Brauchen Sie Wasser oder Strom vor Ort?",
        a: "Ein Wasseranschluss am Gebäude ist hilfreich. Alles Weitere – inklusive der kompletten Technik – bringe ich mit. Details klären wir kurz bei der Besichtigung oder telefonisch.",
    },
    {
        q: "Was kostet eine Pflasterreinigung in Celle?",
        a: "Der Preis richtet sich nach Fläche und Verschmutzungsgrad. Schicken Sie mir gerne ein Foto Ihrer Fläche – Sie erhalten ein verbindliches Festpreis-Angebot, kostenlos und unverbindlich.",
    },
];

export const Hochdruckreinigung = () => (
    <ServicePage
        eyebrow="Leistung · Landkreis Celle"
        h1="Hochdruckreinigung in Celle – Pflaster, Terrasse und Einfahrt wie neu"
        intro="Grünbelag, Moos und eingelagerter Schmutz machen aus gepflegten Außenflächen mit der Zeit graue, rutschige Flächen. Mit professioneller Hochdrucktechnik und Flächenreiniger bringe ich Pflaster, Stein- und Betonflächen im Landkreis Celle wieder auf ihr ursprüngliches Niveau – gründlich und materialschonend."
        image="/leistung-pflasterreinigung.webp"
        imageAlt="Pflasterreinigung in Celle – frisch gereinigter Pflasterweg nach der Hochdruckreinigung"
        scope={[
            "Terrassen und Sitzplätze",
            "Einfahrten und Hofflächen",
            "Gehwege und Hauseingänge",
            "Pflaster-, Beton- und Natursteinflächen",
            "Entfernung von Grünbelag, Algen und Moos",
            "Unkraut und Bewuchs aus den Fugen",
        ]}
        sections={[
            {
                title: "Welche Flächen gereinigt werden können",
                paragraphs: [
                    "Ich reinige Terrassen, Einfahrten, Gehwege, Hofflächen und Zugänge – ob Pflastersteine, Betonplatten, Naturstein oder Klinker. Auch Steinreinigung an Mauersockeln, Treppen und Mauerkronen ist möglich.",
                    "Jede Fläche wird vorab begutachtet: Material, Fugenmaterial und Verschmutzungsgrad entscheiden über die passende Vorgehensweise.",
                ],
            },
            {
                title: "Materialgerecht statt einfach mit vollem Druck",
                paragraphs: [
                    "Der häufigste Fehler bei der Außenflächenreinigung ist zu viel Druck auf dem falschen Material. Dann entstehen Auswaschungen in den Fugen, aufgeraute Steine und Streifen. Ich arbeite deshalb mit angepasstem Druck und einem rotierenden Flächenreiniger, der die Fläche gleichmäßig reinigt – streifenfrei und ohne die Fugen auszuspülen.",
                    "Hartnäckiger Grünbelag und Algen werden vorbehandelt, damit das Ergebnis länger hält und die Fläche nicht unnötig lange unter Wasser steht.",
                ],
            },
            {
                title: "Typische Verschmutzungen, die ich entferne",
                paragraphs: [
                    "Grünbelag und Algen sind nicht nur ein optisches Problem – auf feuchtem Stein werden sie zur Rutschgefahr, gerade an Eingängen und auf Gehwegen. Moos siedelt sich bevorzugt in den Fugen an und lockert sie mit der Zeit auf. Dazu kommen Unkraut, Erdrückstände und dunkle Verfärbungen durch Witterung und Verkehr.",
                    "Nach der Reinigung wirkt die Fläche wieder wie neu verlegt – der Vorher/Nachher-Vergleich weiter unten zeigt ein echtes Projekt aus der Region.",
                ],
            },
        ]}
        pair={BEFORE_AFTER[0]}
        sliderTitle="Vorher / Nachher: Pflasterreinigung"
        faq={faq}
        serviceType="Hochdruckreinigung, Pflasterreinigung und Steinreinigung"
        related={[
            { to: "/gartenpflege-celle", label: "Gartenpflege in Celle" },
            { to: "/heckenschnitt-celle", label: "Heckenschnitt in Celle" },
            { to: "/referenzen", label: "Referenzen ansehen" },
        ]}
    />
);
